import Header from "@components/Header/Header"
import { useLocation, useNavigate } from "react-router"
import { RootContainer, WebSdkContainer } from "./SumsubKYC.styles"
import useLaunchSumsubSDK from "@hooks/useLaunchSumsubSDK"
import LoadingModal from "@components/LoadingModal/LoadingModal"
import ErrorBottomSheet from "@components/ErrorBottomSheet/ErrorBottomSheet"
import { useTranslation } from "react-i18next"

const SumsubKYC = () => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const location = useLocation()
    const levelName = location.state?.levelName

    const { loading, error } = useLaunchSumsubSDK({
        levelName,
        onComplete: async () => { },
        onPending: async () => {
            setTimeout(() => {
                navigate('/completed/under-review')
            }, 2000)
        },
        onError: async () => { }
    })

    const handleRetry = () => {
        navigate('/account-upgrade')
    }

    return (
        <RootContainer>
            <Header
                title={t('components.sumsubKYC.header')}
                showBackButton
                onBackClick={() => navigate('/account-upgrade')}
            />
            <LoadingModal visible={loading} />
            <WebSdkContainer id="sumsub-websdk-container" />
            <ErrorBottomSheet
                isOpen={!!error}
                title={t('components.sumsubKYC.errorTitle')}
                description={error || undefined}
                onClose={() => navigate('/account-upgrade')}
                onRetry={handleRetry}
            />
        </RootContainer>
    )
}

export default SumsubKYC